import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { FeeLadderLevelModel } from "@/core/models/fee-ladder-level.model";

interface _FeeLadderLevelGetParams {
    search?: string;
}

@injectable()
export class FeeLadderLevelRepo extends TableRepo<FeeLadderLevelModel> {
    constructor() {
        super("/api/FeeLadderLevel");
    }

    async getData(index: number, params: _FeeLadderLevelGetParams, pageSize = 10): Promise<ApiPage<FeeLadderLevelModel>|null> {
        return await super.getData(index, params, pageSize);
    }
}